<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M26.832 65.381c.35-.274.525-.655.525-1.143s-.172-.865-.514-1.131c-.342-.267-.811-.4-1.406-.4h-2.658v3.085h2.658c.58 0 1.045-.137 1.395-.41"
      />
      <path
        d="M52.342 70.43c.848.799 1.883 1.198 3.103 1.198 1.042 0 1.868-.244 2.479-.732v-5.082h4.041v6.902c-.625.68-1.526 1.265-2.702 1.753-1.205.473-2.478.71-3.818.71-2.411 0-4.436-.755-6.073-2.264-1.623-1.523-2.434-3.462-2.434-5.814 0-2.367.819-4.305 2.456-5.814 1.623-1.51 3.692-2.264 6.208-2.264 1.622 0 3.14.37 4.555 1.11v3.75c-1.444-.784-2.866-1.176-4.265-1.176-1.415 0-2.576.414-3.483 1.243-.893.829-1.34 1.9-1.34 3.218 0 1.376.424 2.463 1.273 3.262zM43.7 64.948v3.374h-6.252v3.04h8.038v3.506H33.43V59.334h11.879v3.506h-7.86v2.108H43.7zm-24.94 9.92V59.334h6.966c1.756 0 3.14.451 4.153 1.354 1.027.902 1.54 2.071 1.54 3.506 0 1.435-.513 2.611-1.54 3.528-1.013.903-2.397 1.354-4.153 1.354h-2.948v5.792H18.76zm52.446 18.614H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.12 4.148-4.12l37.957-.038V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.155 61.586c0 2.275-1.858 4.125-4.145 4.125zM6.347 74.313v-3.839c.907.68 1.897 1.021 2.969 1.021.907 0 1.574-.2 1.998-.6.424-.399.636-1.057.636-1.974v-9.587h4.02v10.23c0 2.116-.603 3.61-1.81 4.483-1.07.755-2.396 1.132-3.974 1.132-1.682 0-2.962-.289-3.84-.866zM56.48 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
      <path
        d="M45.776 28.58a2.406 2.406 0 0 0-1.87.69l-3.093 3.099-7.89-7.841a2.407 2.407 0 0 0-1.703-.716 2.405 2.405 0 0 0-1.726.859l-11.99 14.3a2.374 2.374 0 0 0 .303 3.357c.401.333.9.527 1.423.552h33.573a2.39 2.39 0 0 0 2.398-2.384c0-.515-.169-1.017-.48-1.43l-7.194-9.533a2.402 2.402 0 0 0-1.75-.954M43.21 14.279c2.65 0 4.797 2.134 4.797 4.767 0 2.632-2.148 4.766-4.796 4.766-2.65 0-4.797-2.134-4.797-4.766 0-2.633 2.148-4.767 4.797-4.767"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-jpeg',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
